import styled from '@emotion/styled';

export const PageWrapper = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  padding-bottom: 58px;

  .main {
    width: 90%;
  }
`;

export const ComplexPageWrapper = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 58px;

  .main {
    width: 90%;
  }
`;
